import last from "lodash/last";

import { notEmpty } from "shared/lib/utils";

import type { AdSlotState } from "scmp-app/components/advertisement/ad-slots/top-banner-ad-slot/atoms";
import { TargetingPaidType } from "scmp-app/components/advertisement/ad-slots/types";
import { isStyleSectionContent } from "scmp-app/components/section/section-style/helpers";

import { SectionTopAdBannerConfigTemplate } from "./consts";

export const getSectionRelatedSectionsQueueName = (fullSectionPath: string[]) => {
  if (fullSectionPath.length === 0) return;

  const getMagazinesStyleSubSectionRelatedQueueName = () => {
    if (fullSectionPath.length !== 4) return;
    if (!isStyleSectionContent(fullSectionPath)) return;

    return `section_categories_${fullSectionPath[2]}`;
  };

  return (
    getMagazinesStyleSubSectionRelatedQueueName() ?? `section_categories_${last(fullSectionPath)}`
  );
};

export const getSectionNameSlug = (name: string) => {
  const sectionNameSlug = name
    .toLowerCase()
    .replaceAll(/\W/g, " ")
    .split(" ")
    .filter(notEmpty)
    .join("_");

  switch (sectionNameSlug) {
    case "paris_olympics_2024":
      return "sport";
    case "this_week_in_asia":
      return "asia";
    default:
      return sectionNameSlug;
  }
};

export const createTopAdBannerConfig = (
  type: keyof typeof SectionTopAdBannerConfigTemplate,
  entityId: string,
  zone: string,
): AdSlotState => {
  const template = SectionTopAdBannerConfigTemplate[type];

  const commonTargeting = {
    paid: TargetingPaidType.NotArticle,
    scsid: [entityId],
    ...template.extraTargeting,
  };

  return {
    desktop: {
      adUnit: "d_banner1",
      sizes: template.desktopSizes as [number, number][],
      targeting: commonTargeting,
      zone,
    },
    mobile: {
      adUnit: "m_banner3",
      sizes: template.mobileSizes as [number, number][],
      targeting: commonTargeting,
      zone,
    },
  };
};
